import api from './api';
import requester from './requester';

const exploreTalentsService = {
    fetchExploreTalentsProfiles: (agencyId, filters, page) => requester(api.exploreTalentsProfiles(agencyId)).create({ filters, page }),
}

export default exploreTalentsService;
